<p>{{ dropDown.title }}<span class='mandatory-title'>{{ isMandatory ? '*' : '' }}</span> </p>
<mat-form-field>
  <input #matInput
    type="text"
    matInput
    [defaultValue]="selectedOption"
    [formControl]="control"
    [matAutocomplete]="autoRo"
    class="input-box"
  />
  <mat-icon fontIcon="arrow_drop_down" class="drop-down-arrow"></mat-icon>
  <mat-autocomplete
    #autoRo="matAutocomplete"
    dropdown-arrow="true"
    [displayWith]="getOptionValue"
    (optionSelected)="onOptionSelected($event)"
    (opened)="onDropdownOpened()">

    <!-- some drop down dont need auto complete function -->
    <ng-container *ngIf="!haveAutoComplete">
      <mat-option *ngFor="let i of Options" [value]=i>{{
        i.value
      }}</mat-option>
    </ng-container>
    <ng-container *ngIf="haveAutoComplete">
    <mat-option *ngFor="let i of filteredOptions | async" [value]=i>{{
      i.value
    }}</mat-option>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
<button matButton class="dropDownClearBtn" (click)="clearField()"
*ngIf="!disabled"><mat-icon>close</mat-icon></button>
<p class="assistive-text">{{ dropDown.assistive }}</p>
